import React from "react";
import BeatLoader from "react-spinners/BeatLoader";

const BeatLoading = ({ loading }) => {
    return (
        <BeatLoader
        color="#E74C3C"  
        loading={loading} 
        size={8}         
        />
    );
};

export default BeatLoading;